module.exports = __webpack_public_path__ + "static/media/right-arrow.bada0d8a.svg";